import { nannyAnswers, nannyBlocks } from '@common/model/client/training/nanny';
import { TrainingBlockModel } from 'src/features/client/training/model/block';

export const nannyFlowFactory = () => {
  return nannyBlocks.map((blockConfig) => new TrainingBlockModel(blockConfig, nannyAnswers[blockConfig.id]));
};
